
import { mapState, mapGetters, mapActions } from 'vuex';
import ReviewResourceView from '@/mixins/ReviewResourceView';
import ThumbnailShape from '@/enums/ThumbnailShape';

export default {
  i18nComponentKey: 'WidgetCategoryReviewsHorizontalScroll.components.HorizontalScroll',
  name: 'HorizontalScroll',
  mixins: [ReviewResourceView],
  props: {
    cols: { type: Number, required: true },
    productImageSize: { type: Number, required: true }
  },
  data() {
    return {
      minPanelWidthPc: 100,
      pcGap: 20
    };
  },
  computed: {
    ...mapState('reviewSettings', ['reviewSettings']),
    ...mapGetters('widget', [
      'appHeaderShowable',
      'device',
      'headerSectionShowable',
      'showFilterSection',
      'thumbnailShape'
    ]),
    productThumbnailType() {
      return this.widget.product_thumbnail_shape === ThumbnailShape.SQUARE
        ? 'rounded'
        : 'circle';
    },
    isCircular() {
      if (this.widget.horizontal_scroll_enable_autoscroll) return true;
      if (!this.widget.horizontal_scroll_show_see_all_at_last_slide)
        return true;
      return false;
    },
    carouselProps() {
      return {
        cols: this.cols,
        circular: this.isCircular,
        panelsPerView: this.device === 'mobile' ? this.cols + 0.2 : this.cols,
        minCarouselWidth:
          this.device === 'pc'
            ? this.minPanelWidthPc * this.cols + this.pcGap * (this.cols - 1)
            : 0,
        autoPlay: this.widget.horizontal_scroll_enable_autoscroll,
        delay: this.widget.horizontal_scroll_autoscroll_delay,
        ...this.paginationOptions
      };
    },
    paginationOptions() {
      return {
        showPagination: this.device === 'pc',
        paginationOnTop: this.device === 'pc',
        paginateByPanel: false,
        totalCount: this.widget.horizontal_scroll_show_see_all_at_last_slide
          ? this.reviews.length + 1
          : this.reviews.length
      };
    },
    contentsStyle() {
      return {
        '--min-height': this.showFilterSection ? '204px' : 'auto'
      };
    },
    carouselKey() {
      return this.reviews.map(review => review.id).join('-');
    }
  },
  methods: {
    ...mapActions('widget', ['openReviewPopup']),
    submit(params) {
      this.searchResource(params);
    }
  }
};
